import { env, type DataSource } from "@/config/env"
import type { Services } from "@/services/ports"
import { createAccreditationService } from "@/services/accreditation"
import { createHttpClient } from "@/services/api/httpClient"
import { createApiContentService, createApiNetworkService, createApiPlansService } from "@/services/api"
import { createStaticContentService } from "@/services/static/content.static"
import { createStaticNetworkService } from "@/services/static/network.static"
import { createStaticPlansService } from "@/services/static/plans.static"

/**
 * Monta o conjunto de services da fonte pedida.
 *
 * Este e o unico ponto do codigo que sabe que existe mais de uma fonte de
 * dados. Componentes importam `services`; testes chamam `createServices` com a
 * fonte que quiserem.
 */
export function createServices(source: DataSource = env.dataSource): Services {
  // O credenciamento e escrita e tem destino proprio: ele nao acompanha
  // `source`. Ver o cabecalho de `services/accreditation.ts`.
  const accreditation = createAccreditationService(env.accreditationEndpoint)

  if (source === "api") {
    const http = createHttpClient(env.apiBaseUrl)

    return {
      plans: createApiPlansService(http),
      network: createApiNetworkService(http),
      content: createApiContentService(http),
      accreditation,
    }
  }

  return {
    plans: createStaticPlansService(),
    network: createStaticNetworkService(),
    content: createStaticContentService(),
    accreditation,
  }
}

/** Instancia usada pela aplicacao. */
export const services = createServices()

export type { Services } from "@/services/ports"
